import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Home from './containers/Home';
import Error404 from './containers/errors/Error404';

import Signup from './containers/auth/Signup';
import Login from './containers/auth/Login';
import Activate from './containers/auth/Activate';
import ResetPassword from './containers/auth/ResetPassword';
import ResetPasswordConfirm from './containers/auth/ResetPasswordConfirm';
import ResendActivation from './containers/auth/ResendActivation';

import Shop from './containers/Shop';
import ProductDetail from './containers/pages/productDetail';

import Search from './containers/pages/Search';
import Cart from './containers/pages/Cart';
import Checkout from './containers/pages/Checkout';
import ThankYou from './containers/pages/ThankYou';
import Dashboard from './containers/pages/Dashboard';
import DashboardPayments from './containers/pages/DashboardPayments';
import DashboardPaymentDetail from './containers/pages/DashboardPaymentDetail';
import DashboardProfile from './containers/pages/DashboardProfile';

import DashboardUserOrder from './containers/pages/client/Orders/DashboardUserOrder';
import DashboardUserOrderDetail from './containers/pages/client/Orders/DashboardUserOrderDetail';
import DashboardShipping from './containers/pages/client/Shipping/DashboardShipping';
import DashboardShippingEdit from './containers/pages/client/Shipping/DashboardShippindEdit';
import DashboardShippingCreate from './containers/pages/client/Shipping/DashboardShippingCreate';
import DashboardStoreProduct from './containers/pages/client/Products/DashboardStoreProduct';
import DashboardCategories from './containers/pages/client/Categories/DashboardCategories';
import DashboardCategoriesEdit from './containers/pages/client/Categories/DashboardCategoriesEdit';
import DashboardCategoriesCreate from './containers/pages/client/Categories/DashboardCategoriesCreate';
import DashboardStoreProductEdit from './containers/pages/client/Products/DashboardStoreProductEdit';
import DashboardStoreProductCreate from './containers/pages/client/Products/DashboarStoreProductCreate';
import Google from './containers/pages/Google';
import Microsoft from './containers/pages/Microsoft';
import Terms from './containers/pages/term/Terminos';
import Policy from './containers/pages/term/Politicas';
import CheckoutSuccess from './containers/pages/Success';
import Contact from './containers/pages/Contact';



function App() {
  return (
 <Provider store={store}>
      <Router>
        <Routes>
          {/* Error Display */}
          <Route path="*" element={<Error404/>}/>

          <Route exact path='/' element={<Home/>}/>
          <Route exact path='/cart' element={<Cart/>}/>
          <Route exact path='/checkout' element={<Checkout/>}/>
          <Route exact path='/google' element={<Google/>}/>
          <Route exact path='/microsoft' element={<Microsoft/>}/>
          {/* Authentication */}
          <Route exact path='/signup' element={<Signup/>}/>
          <Route exact path='/login' element={<Login/>}/>
          <Route exact path='/activate/:uid/:token' element={<Activate/>}/>
          <Route exact path='/reset_password' element={<ResetPassword/>} />
          <Route exact path='/resend_activation' element={<ResendActivation/>} />
          <Route exact path='/password/reset/confirm/:uid/:token' element={<ResetPasswordConfirm/>} />

          <Route exact path='/shop' element={<Shop/>}/>
          <Route exact path='/product/:productId' element={<ProductDetail/>}/>
          <Route exact path='/search' element={<Search/>}/>

          <Route exact path='/thankyou' element={<ThankYou/>}/>
          
          <Route exact path='/dashboard' element={<Dashboard/>}/>
          <Route exact path='/dashboard/payments' element={<DashboardPayments/>}/>
          <Route exact path='/dashboard/payment/:transaction_id' element={<DashboardPaymentDetail/>}/>
          <Route exact path='/dashboard/profile' element={<DashboardProfile/>}/>
          {/* Cliente Configuracion de la Tienda */}

          <Route exact path='/dashboard/products' element={<DashboardStoreProduct/>}/>
          <Route exact path='/add-product' element={<DashboardStoreProductCreate/>}/>
          <Route exact path='/edit-product/:id' element={<DashboardStoreProductEdit/>}/>
          <Route exact path='/dashboard/client-orders' element={<DashboardUserOrder/>}/>
          <Route exact path='/dashboard/client-orders/:id' element={<DashboardUserOrderDetail/>}/>
          <Route exact path='/dashboard/shipping' element={<DashboardShipping/>}/>
          <Route exact path='/add-shipping' element={<DashboardShippingCreate/>}/>
          <Route exact path='/edit-shipping/:id' element={<DashboardShippingEdit/>}/>
          <Route exact path='/dashboard/categories' element={<DashboardCategories/>}/>
          <Route exact path='/add-category' element={<DashboardCategoriesCreate/>}/>
          <Route exact path='/edit-category/:id' element={<DashboardCategoriesEdit/>}/>



          <Route exact path='/success' element={<CheckoutSuccess/>}/>
          <Route exact path='/terms' element={<Terms/>}/>
          <Route exact path='/policys' element={<Policy/>}/>
          <Route exact path='/contact' element={<Contact/>}/>
        </Routes>
      </Router>
    </Provider>

  );
}

export default App;
